import { z } from 'zod';

export const UserCertificationProductSchema = z.object({
  productNumber: z.number().int(),
  productName: z.string(),
  hasCertification: z.boolean(),
});
export type UserCertificationProduct = z.infer<typeof UserCertificationProductSchema>;
